var exports = {
  "h": "x4c3adb35--03f1ab--trigger",
  "Y": "x4c3adb35--03f1ab--tooltip",
};

module.exports = exports;
